import {InputSelect} from '@/components/commons/input-select/InputSelect'
import {ProjectFieldsSchema} from '@/features/projects/formSchemas'
import {projectSenderToLabel} from '@/features/projects/utils'
import {useTranslation} from '@/translations/i18n'
import {useController, useFormContext, useWatch} from 'react-hook-form'
import {z} from 'zod'

const ProjectFormSenderSchema = ProjectFieldsSchema.pick({
    id: true,
    sender: true,
    referringProject: true
})
type ProjectFormSenderSchema = z.infer<typeof ProjectFormSenderSchema>

export const ProjectFormSenderField = () => {
    const {t} = useTranslation()
    const {control} = useFormContext<ProjectFormSenderSchema>()
    const {field} = useController({control, name: 'sender'})
    const projectId = useWatch({control, name: 'id'})
    const referringProject = useWatch({control, name: 'referringProject'})

    return (
        <InputSelect
            {...field}
            value={field.value ?? undefined}
            optionsMap={projectSenderToLabel}
            onClear={!projectId || referringProject ? () => field.onChange(null) : undefined}
            label={t('projects:select_sender_label')}
        />
    )
}
